import Modal from "@/Components/Modal";
import TextInput from "@/Components/TextInput";
import InputLabel from "@/Components/InputLabel";
import PrimaryButton from "@/Components/PrimaryButton";
import SecondaryButton from "@/Components/SecondaryButton";
import {useState} from "react";

export type EditNameModalProps = {
    show: boolean;
    onClose: () => void;
    name: string;
    onUpdated: (name: string) => void;
}

export default function ({show, onClose, name, onUpdated}: EditNameModalProps) {
    const [nameVal, setNameVal] = useState(name);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onUpdated(nameVal);
    };

    return (
        <Modal maxWidth='md' show={show} onClose={onClose}>
            <div className="p-6">
                <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-gray-100 mb-4">
                    Rename
                </h3>

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <InputLabel htmlFor="name" value="Name" className="mb-2" />
                        <TextInput
                            id="name"
                            type="text"
                            value={nameVal}
                            onChange={(e) => setNameVal(e.target.value)}
                            className="w-full"
                            isFocused
                        />
                    </div>

                    <div className="flex justify-end">
                        <SecondaryButton
                            type="button"
                            className="me-2"
                            onClick={onClose}
                        >
                            Cancel
                        </SecondaryButton>
                        <PrimaryButton
                            type="submit"
                        >
                            Save
                        </PrimaryButton>
                    </div>
                </form>
            </div>
        </Modal>
    )
}
